var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIceHockey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1217.000000, -475.000000)",
    fill: "#0000008a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1213.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "-0.25 5.83333333 1.75 5.83333333 1.75 14.0833333 -0.25 14.0833333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4166667,13.5 C5.49425478,13.5 -0.25,10.4227207 -0.25,6.25 C-0.25,2.07727934 5.49425478,-1 12.4166667,-1 C19.3390786,-1 25.0833333,2.07727934 25.0833333,6.25 C25.0833333,10.4227207 19.3390786,13.5 12.4166667,13.5 Z M12.4166667,11.5 C18.3808989,11.5 23.0833333,8.98083872 23.0833333,6.25 C23.0833333,3.51916128 18.3808989,1 12.4166667,1 C6.45243439,1 1.75,3.51916128 1.75,6.25 C1.75,8.98083872 6.45243439,11.5 12.4166667,11.5 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0833333,13.6666667 L25.0833333,13.6666667 C25.0833333,17.8107975 19.2990082,20.9166667 12.4166667,20.9166667 C5.5343251,20.9166667 -0.25,17.8107975 -0.25,13.6666667 L1.75,13.6666667 C1.75,16.370237 6.49243331,18.9166667 12.4166667,18.9166667 C18.3409,18.9166667 23.0833333,16.370237 23.0833333,13.6666667 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "23.0833333 5.83333333 25.0833333 5.83333333 25.0833333 14.0833333 23.0833333 14.0833333"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceHockey);
export default __webpack_public_path__ + "static/media/iceHockey.54d9815e64d90852b9234036417b8b4d.svg";
export { ForwardRef as ReactComponent };